import { JsonObject, JsonProperty } from 'json2typescript';

import { AgentInterface } from '../../../core';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('Agent')
export class Agent implements AgentInterface {
    @JsonProperty('Code', IdAdapter, true)
    private _code: Id = undefined;

    @JsonProperty('FullName', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('UserCode', StringAdapter, true)
    private _userCode: string = undefined;

    get code(): Id {
        return this._code;
    }

    set code(value: Id) {
        this._code = value;
    }

    get name(): string {
        return this._name;
    }

    get userCode(): string {
        return this._userCode;
    }
}
